import { render } from "./top-bar.vue?vue&type=template&id=583eec0c&scoped=true"
import script from "./top-bar.vue?vue&type=script&lang=js"
export * from "./top-bar.vue?vue&type=script&lang=js"

import "./top-bar.vue?vue&type=style&index=0&id=583eec0c&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583eec0c"]])

export default __exports__